import React, { useState,useEffect } from 'react';
import DashboardIcon from '../assets/svgs/Dashboard.svg'
import toast from 'react-hot-toast';
import { postData } from '../helpers/api-helper';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { requestForToken } from '../components/firebase';

export default function Verification(props){

    const { t } = useTranslation();
    const {state} = useLocation()

    const [verification,set_verification] = useState(true)
    const [done,set_done] = useState(false)
    const [verification_code,set_verification_code] = useState("")

    const [full_name,set_full_name] = useState(state?.full_name ?? "")
    const [new_full_name,set_new_full_name] = useState(state?.new_full_name ?? "")
    const [email,set_email] = useState(state?.email ?? "")
    const [customer_code,set_customer_code] = useState(state?.customer_code ?? "")
    const [new_email,set_new_email] = useState(state?.new_email ?? "")
    const [change_email,set_change_email] = useState(false)

    const [seconds,set_seconds] = useState(30)
    const [loading,set_loading] = useState(false)
    const [is_email_valid,set_is_email_valid] = useState(false)
    const [name_diff,set_name_diff] = useState(false)

    const navigate = useNavigate()

    useEffect(() => {
        const interval = setInterval(() => {
            if(seconds > 0){
                set_seconds(seconds-1)
            }
            if(seconds === 0){
                clearInterval(interval)
            }
        },1000)

        return() => {
            clearInterval(interval)
        }
    },[seconds])

    useEffect(() => {
        const timeOutId = setTimeout(() => handleOnChange(email), 1500);
        return () => clearTimeout(timeOutId);
    }, [email]);
    
    const handleOnChange = ( email ) => {

        // don't remember from where i copied this code, but this works.
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        
        if ( (re.test(email) && email != "") ) {
            toast.success(t('auth.alert.email_format_valid'))
            set_is_email_valid(true)
        }else if(email != "") {
            toast.error(t('auth.alert.email_format_invalid'))
            set_is_email_valid(false)
        }
    
    }

    const resendToken=async()=>{
        var params = {email:email}
        set_loading(true)
        await postData(`${process.env.REACT_APP_API}/resend-token`,params).then((response) => {
            if(response.status === 200){
                set_seconds(10)
                toast.success(t('auth.alert.token_resended'))
            }
            set_loading(false)
        }).catch((e) => 
            set_loading(false))
    }

    const verifyToken=async ()=>{
        var params = {email:email,otp:verification_code,device_id:global.device_id,customer_code:customer_code}
        set_loading(true)
        await postData(`${process.env.REACT_APP_API}/verify-token`,params).then((response) => {
            if(response.data.status_code === 200){
                if(response.data.data?.user){
                    set_verification(false)
                    set_done(true)
                    requestForToken(response.data.data?.data_user.id)
                    if(response.data.data?.user[0].new_full_name != response.data.data?.user[0].full_name){
                        set_name_diff(true)
                        console.log(response.data.data?.user[0])
                        set_full_name(response.data.data?.user[0].full_name)
                        set_new_full_name(response.data.data?.user[0].new_full_name)
                        toast.success(t('auth.alert.verify_success_but_name'))
                    }else{
                        toast.success(t('auth.alert.verify_success'))
                        set_full_name("")
                        set_email("")
                        set_verification_code("")
                        navigate('/login')
                    }
                }
            }else{
                toast.error(response.data.message)
            }
            set_loading(false)
        }).catch((e) => 
            set_loading(false))
    }

    const submitChangeEmail=async()=>{
        if(is_email_valid){
            var params = {email:email,new_email:new_email,customer_code:customer_code}
            set_loading(true)
            await postData(`${process.env.REACT_APP_API}/change-email`,params).then((response) => {
                if(response.data.status_code === 200){
                    toast.success(t('auth.alert.change_email_success'))
                    set_change_email(false)
                    set_email(new_email)
                }else{
                    toast.error(response.data.message)
                }
                set_loading(false)
            }).catch((e) => 
                set_loading(false))
        }else{
            toast.error(t('auth.alert.email_format_invalid'))
        }
    }

    const confirmName=async(name)=>{
        var params = {email:email,new_full_name:name,customer_code:customer_code}
        set_loading(true)
        await postData(`${process.env.REACT_APP_API}/change-name`,params).then((response) => {
            global.full_name = name
            if(response.data.status_code === 200){
                toast.success(t('auth.alert.change_name_success'))
                set_name_diff(false)
                set_done(true)
                props.navigation.navigate('PostLogin')
            }else{
                toast.error(response.data.message)
            }
            set_loading(false)
        }).catch((e) => 
            set_loading(false))
    }

    const FormPage=()=>{
        if(verification){
            return(
                <>
                <div className='text-center px-5'>
                    <h2 className='color-2'>{t('auth.message_verification')} {email}</h2>
                    <h2 className='color-3' onClick={() => set_change_email(true)}>{t('auth.change_email')}</h2>
                </div>
                {!change_email  ? 
                <>
                <div className="mt-10 grid px-8">
                    <div className="my-5">
                        <input type="text" name="verification_code" id="verification_code" placeholder='Verification code' onChange={(e) => set_verification_code(e.target.value)} value={verification_code} className="block w-full input-1"/>
                    </div>
                </div>
                <div className="mt-10 px-8">
                    { loading ? 
                    <div role="status" className="mt-2 flex justify-center">
                        <svg aria-hidden="true" class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-red-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                        </svg>
                        <span class="sr-only">Loading...</span>
                    </div> : 
                    <>
                    <div className="mt-2 flex justify-center">
                        <button className='btn-register' onClick={(e) => verifyToken()}>{t('auth.verify')}</button>
                    </div>
                    <div className="mt-2 flex justify-center">
                        <p className='color-lvl-4'>Or</p>
                    </div>
                    <div className="mt-2 flex justify-center">
                        <button className={'btn-resend'} onClick={(e) => resendToken()} disabled={seconds > 0}>{t('auth.resend')} {seconds > 0 ? "("+seconds+")" : ""}</button>
                    </div>
                    </>}
                </div> </>:
                    <div className="mt-10 grid px-8">
                        <div className="my-3">
                            <input disabled={true} type="email" name="email" id="email" placeholder='Email Address' onChange={(e) => set_email(e.target.value)} value={email} className="block w-full input-1"/>
                        </div>
                        <div className="my-3">
                            <input type="email" name="new_email" id="new_email" placeholder='New Email Address' onChange={(e) => set_new_email(e.target.value)} value={new_email} className="block w-full input-1"/>
                        </div>
                        <div className="mt-2 flex justify-center">
                        { loading ? 
                            <div role="status" className="mt-2 flex justify-center">
                                <svg aria-hidden="true" class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-red-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                </svg>
                                <span class="sr-only">Loading...</span>
                            </div> : 
                            <button type='button' className='btn-register' onClick={(e) => submitChangeEmail()}>Submit</button>
                        }
                        </div>
                    </div>
                }
                </>
            )
        }else if(name_diff){
            return(
                <>
                    <div className='text-center px-5'>
                        <h2 className='color-lvl-4'>
                            {t('auth.message_name_diff')}
                        </h2>
                    </div>
                    <div className="mt-10 px-8">
                        { loading ? 
                        <div role="status" className="mt-2 flex justify-center">
                            <svg aria-hidden="true" class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-red-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                            </svg>
                            <span class="sr-only">Loading...</span>
                        </div> : 
                        <>
                        <div className="mt-2 flex justify-center">
                            <button className='btn-register' onClick={(e) => confirmName(full_name)}>{full_name}</button>
                        </div>
                        <div className="mt-2 flex justify-center">
                            <p className='color-lvl-4'>Or</p>
                        </div>
                        <div className="mt-2 flex justify-center">
                            <button className={'btn-resend'} onClick={(e) => confirmName(new_full_name)}>{new_full_name}</button>
                        </div>
                        </>}
                    </div>
                </>
            )
        }else if(done){
            return(
                <div className="my-10 flex">
                    <button className='btn-register' onClick={(e) => navigate('/dashboard')}>View Dashboard</button>
                </div>
            )
        }
    }

    return(
        <form style={{height:'100vh'}}>
            <div class="grid grid-cols-2 gap-4 mb-4">
                <div className="py-10 px-10">
                    <header className="pl-10 flex">
                        <img src={process.env.PUBLIC_URL + '/logo192.png'} alt="logo" width={'7%'}/>
                        <h2 className='my-auto ml-5 font-semibold text-2xl color-2'>Vancare App</h2>
                    </header>
                    {FormPage()}
                </div>
                <div className="background-page" style={{height:'100vh'}}>
                </div>
            </div>
        </form>
    )
 }